import { objectKeysToCamelCase, objectKeysToSnakeCase } from '@mint-lib/api';

import { socketBuilder } from './socket-builder.js';
import type {
  SocketBuilderConfig,
  SocketBuilderInstance,
} from './types/index.js';

/**
 * Mint-flavored socketBuilder. Defaults formatMessage/parseMessage to wrap
 * upstream's Socket.IO array format with snake_case (outgoing) and camelCase
 * (incoming) transforms. New code should prefer this over raw `socketBuilder()`
 * unless a custom wire format is needed.
 */
export function createMintSocketBuilder(
  config: SocketBuilderConfig = {},
): SocketBuilderInstance {
  return socketBuilder({
    ...config,
    formatMessage:
      config.formatMessage ??
      ((_topic, payload, _ackId) => {
        const snake =
          payload && typeof payload === 'object'
            ? objectKeysToSnakeCase(payload as Record<string, unknown>)
            : payload;
        return snake;
      }),
    parseMessage:
      config.parseMessage ??
      ((data: { event: string; payload: unknown }) => {
        const raw = data.payload;
        const camel =
          raw && typeof raw === 'object'
            ? objectKeysToCamelCase(raw as Record<string, unknown>)
            : raw;
        return {
          topic: data.event,
          payload: camel,
        };
      }),
  });
}
